import React, { useState, useEffect } from "react";
import { XCircle } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css-dashboard/Dashboard.css";
import SidebarClient from "../../components/sidebar-dashboard/SidebarClient";
import ClientTripsProgressNegotiations from "../../components/client-trips-negotiations/ClientTripsProgressNegotiations";
import UseClientTripsNegotiations from "../../hooks/UseTripsNegotiations/UseClientTripsNegotiations";
import UseNotAcceptOrderTripNegotiation from "../../hooks/UseNotAcceptOrderTripNegotiation/UseNotAcceptOrderTripNegotiation";
import UseModalReceiverData from "../../hooks/UseModalReceiverData/UseModalReceiverData";
import ModalReceiverData from "../../components/modal-receiver-data/ModalReceiverData";
import UseModalPhotosOrder from "../../hooks/UseModalPhotosOrder/UseModalPhotosOrder";
import ModalPhotosOrder from "../../components/modal-photos-order/ModalPhotosOrder";
import UseModalChat from "../../hooks/UseModalChat/UseModalChat";
import ModalChat from "../../components/modal-chat/ModalChat";

const placeholderImage =
  "https://img.magnific.com/premium-vector/3d-cardboard-box-clipboard-with-tick-confirmed-order-delivery-concept-shipment-checklist-delivery-order-cardboard-box-fast-delivery-concept-mail-by-courier-vector-illustration_221648-1116.jpg?semt=ais_hybrid&w=740&q=80";

const TripsProgressClient = ({ menuOpen, setMenuOpen }) => {
  const location = useLocation();
  const { state, pathname } = location;
  const navigate = useNavigate();

  const [showRefuseModal, setShowRefuseModal] = useState(false);
  const [serieCancelOrder, setSerieCancelOrder] = useState("");
  const [modalWarning, setModalWarning] = useState(true);
  const [fromNotification, setFromNotification] = useState(null);
  const [imageNotification, setImageNotification] = useState(null);
  const [messageNotification, setMessageNotification] = useState(null);

  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseClientTripsNegotiations();

  const {
    isOpenReceiverData,
    showSuccessScreenReceiverData,
    openModalReceiverData,
    closeModalReceiverData,
    selectedNegotiationReceiverData,
    formDataReceiverData,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingReceiverData,
    errorReceiverData,
    successReceiverData,
    errorsReceiverData,
  } = UseModalReceiverData(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenPhotosOrder,
    showSuccessScreenPhotosOrder,
    selectedNegotiationPhotosOrder,
    photosPhotosOrder,
    loadingPhotosOrder,
    errorPhotosOrder,
    successPhotosOrder,

    openPhotosOrderModal,
    closePhotosOrderModal,

    handleChangePhotoOrder,
    handleSubmitPhotosOrder,
  } = UseModalPhotosOrder(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenChat,
    selectedNegotiationChat,
    currentRoleChat,
    messagesChat,
    messageChat,
    emojiList,
    setShowEmojiPickerChat,
    showEmojiPickerChat,
    handleEmojiSelect,
    loadingMessagesChat,
    sendingChat,
    errorChat,
    messagesEndRef,
    openChatModal,
    closeChatModal,
    handleMessageChange,
    handleSendMessage,
  } = UseModalChat(() => {
    refetchTripsNegotiations();
  });

  const { loadingCancelOrder, cancelOrder } =
    UseNotAcceptOrderTripNegotiation();

  const handleCancelOrder = async (serie) => {
    await cancelOrder(serie, "client");
    setShowRefuseModal(false);
  };

  useEffect(() => {
    if ((fromNotification && state?.from) || state?.notification_type) {
      window.location.reload();
      navigate(pathname, {
        replace: true,
        state: {
          ...state,
          from: null,
          notification_type: null,
        },
      });
    }
  }, [
    fromNotification,
    state?.from,
    state?.notification_type,
    pathname,
    navigate,
  ]);

  useEffect(() => {
    const state = location.state;
    if (!state || !state.from) return;

    const type = state.notification_type?.trim();
    const item = state.item;

    console.log(location.state?.item);

    if (location.state?.item?.trip_status === "3" && type === "service") {
      setFromNotification("notification");
      setImageNotification(location.state?.item?.traveler?.imagem);
      setMessageNotification(
        <>
          O viajante{" "}
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {location.state?.item?.traveler?.nome}
          </span>{" "}
          já efetuou o pagamento do seguro, insira os dados de destinatário que
          irá receber a encomenda
        </>,
      );
    } /*else if (
      location.state?.item?.trip_status === "traveler_recused_order" &&
      type === "cancel-order"
    ) {
      setFromNotification("notification");
      setImageNotification(location.state?.item?.traveler?.imagem);
      setMessageNotification(
        <>
          O viajante{" "}
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {location.state?.item?.traveler?.nome}
          </span>{" "}
          desistiu de levar sua encomenda. Você receberá o valor do serviço em
          até 2 horas. Experimente reduzir o valor do seguro para deixar sua
          encomenda mais atrativa na próxima tentativa.
        </>,
      );
    }*/ else if (type === "receiver-selected-client") {
      setFromNotification("notification");
      setImageNotification(location.state?.item?.receiver?.imagem);
      setMessageNotification(
        <>
          Agora que o destinatário{" "}
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {location.state?.item?.receiver?.nome}
          </span>{" "}
          confirmou a sua disponibilidade, você já pode seguir com os próximos
          passos.
        </>,
      );
    } else if (type === "cancel-order-client") {
      setFromNotification("notification");
      setImageNotification(placeholderImage);
      setMessageNotification(<>Encomenda recusada com sucesso.</>);
    } else if (type === "receiver-refused") {
      openModalReceiverData(item, "receiverReadded");
    } else if (
      location.state?.item?.is_traveler_photos_confirmed === true &&
      type === "photo-upload-client"
    ) {
      setFromNotification("notification");
      setImageNotification(location.state?.item?.traveler?.imagem);
      setMessageNotification(
        <>
          Agora que o carteiro{" "}
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {location.state?.item?.traveler?.nome}
          </span>{" "}
          confirmou as fotografias da encomenda, acompanhe a encomenda até o seu
          destino
        </>,
      );
    } else if (type === "chat") {
      openChatModal(item, "client");
    }
  }, [location]);

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarClient menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Cliente</h1>
            <p className="breadcrumb">
              <a href="/dashboard-client">Início</a> / Solicitações em Andamento
            </p>
          </div>

          <ClientTripsProgressNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverModal={openModalReceiverData}
            onOpenPhotosOrderModal={openPhotosOrderModal}
            onOpenChatModal={openChatModal}
            setSerieCancelOrder={setSerieCancelOrder}
            setShowRefuseModal={setShowRefuseModal}
          />
        </main>
      </div>

      <ModalReceiverData
        isClient={true}
        isOpenReceiverData={isOpenReceiverData}
        showSuccessScreenReceiverData={showSuccessScreenReceiverData}
        closeModalReceiverData={closeModalReceiverData}
        formDataReceiverData={formDataReceiverData}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingReceiverData={loadingReceiverData}
        errorReceiverData={errorReceiverData}
        errorsReceiverData={errorsReceiverData}
        successReceiverData={successReceiverData}
        selectedNegotiationReceiverData={selectedNegotiationReceiverData}
      />

      <ModalPhotosOrder
        isOpenPhotosOrder={isOpenPhotosOrder}
        closePhotosOrderModal={closePhotosOrderModal}
        showSuccessScreenPhotosOrder={showSuccessScreenPhotosOrder}
        selectedNegotiationPhotosOrder={selectedNegotiationPhotosOrder}
        photosPhotosOrder={photosPhotosOrder}
        loadingPhotosOrder={loadingPhotosOrder}
        errorPhotosOrder={errorPhotosOrder}
        successPhotosOrder={successPhotosOrder}
        modePhotosOrder="upload"
        handlePhotoChange={handleChangePhotoOrder}
        handleSubmit={handleSubmitPhotosOrder}
      />

      <ModalChat
        isOpenChat={isOpenChat}
        selectedNegotiationChat={selectedNegotiationChat}
        currentRoleChat={currentRoleChat}
        messagesChat={messagesChat}
        messageChat={messageChat}
        emojiList={emojiList}
        setShowEmojiPickerChat={setShowEmojiPickerChat}
        showEmojiPickerChat={showEmojiPickerChat}
        handleEmojiSelect={handleEmojiSelect}
        loadingMessagesChat={loadingMessagesChat}
        sendingChat={sendingChat}
        errorChat={errorChat}
        messagesEndRef={messagesEndRef}
        closeChatModal={closeChatModal}
        handleMessageChange={handleMessageChange}
        handleSendMessage={handleSendMessage}
      />

      {modalWarning && fromNotification === "notification" && (
        <div
          className="modal-overlay"
          onClick={() => {
            setModalWarning(false);
            setFromNotification(null);
          }}
          style={{
            alignItems: "flex-start",
            overflowY: "auto",
            padding: "20px 12px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "520px",
              margin: "auto",
              padding: "32px 28px",
              borderRadius: "30px",
              overflow: "hidden",
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0.92))",
              backdropFilter: "blur(18px)",
              WebkitBackdropFilter: "blur(18px)", // Garante suporte para o Safari
              boxShadow:
                "0 20px 60px rgba(15, 124, 255, 0.18), 0 8px 20px rgba(0, 0, 0, 0.06)",
              textAlign: "center",
            }}
          >
            <>
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    width: "155px",
                    height: "155px",
                    margin: "auto",
                    borderRadius: "50%",
                    padding: "5px",
                    background: "linear-gradient(135deg, #0f7cff, #19b8ff)",
                    boxShadow:
                      "0 14px 35px rgba(15, 124, 255, 0.35), 0 5px 14px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.35s ease",
                  }}
                >
                  <img
                    src={imageNotification}
                    alt="Foto de perfil"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "5px solid #fff",
                      display: "block",
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  textAlign: "left",
                  color: "#616367",
                  marginBottom: "6px",
                }}
              >
                {messageNotification || ""}
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="action-btn ghost"
                  onClick={() => {
                    setModalWarning(false);
                    setFromNotification(null);
                  }}
                >
                  Entendi
                </button>
              </div>
            </>
          </div>
        </div>
      )}

      {showRefuseModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowRefuseModal(false)}
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "90%",
              maxWidth: "500px",
              background: "#fff",
              borderRadius: "24px",
              padding: "30px",
              textAlign: "center",
              boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            }}
          >
            <XCircle
              size={70}
              color="#ef4444"
              style={{ marginBottom: "16px" }}
            />

            <h2
              style={{
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              Confirmar cancelamento
            </h2>

            <p
              style={{
                color: "#6b7280",
                lineHeight: 1.6,
                marginBottom: "24px",
              }}
            >
              Tem certeza que deseja cancelar a encomenda?
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                onClick={() => setShowRefuseModal(false)}
                className="action-btn ghost"
                style={{
                  width: "50%",
                  height: "50px",
                }}
              >
                Voltar
              </button>

              <button
                type="button"
                className="refuse-order-btn"
                onClick={() => handleCancelOrder(serieCancelOrder)}
                disabled={loadingCancelOrder}
                style={{
                  width: "50%",
                  height: "50px",
                }}
              >
                {loadingCancelOrder ? "Cancelando..." : "Sim, cancelar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TripsProgressClient;
